import { CreationLayout } from './CreationLayout';

interface WelcomeStageProps {
  onContinue: () => void;
}

export function WelcomeStage({ onContinue }: WelcomeStageProps): JSX.Element {
  return (
    <CreationLayout stageKey="welcome">
      <div className="px-6 sm:px-10 pt-10 pb-8 text-center">
        <p className="text-candle-dark text-[0.7rem] uppercase tracking-[0.4em] mb-3">
          Cutlass Cove &middot; Dawn
        </p>
        <h1 className="font-display text-3xl sm:text-4xl text-ink mb-6">Your Tale Begins</h1>
        <div className="mx-auto h-px w-16 bg-candle/60 mb-6" />
        <div className="space-y-4 text-ink-mid text-base sm:text-lg leading-relaxed text-balance">
          <p>
            The salt air bites at your skin. Cutlass Cove rises from the morning fog &mdash; a
            tangle of wooden docks and weathered taverns clinging to a hidden bay. You have nothing
            but the clothes on your back, a few coins in your pocket, and a story that brought you
            here.
          </p>
          <p>
            What that story is, no one in this town will ask. What matters now is what comes next.
          </p>
        </div>
      </div>
      <div className="px-6 sm:px-10 pb-10 pt-2">
        <button
          type="button"
          onClick={onContinue}
          className="w-full inline-flex items-center justify-center rounded-md bg-sea-deep text-candle border border-candle/40 hover:bg-sea-dark hover:border-candle px-5 py-3 font-display tracking-[0.2em] uppercase text-sm transition-colors min-h-11 focus:outline-none focus:ring-2 focus:ring-candle focus:ring-offset-2 focus:ring-offset-parchment"
        >
          Step Ashore
        </button>
      </div>
    </CreationLayout>
  );
}
